// SP-2 — the tag mark: a hanging tag in the theme's key colour with the
// count in its body. No word beside it; the number is the count. Printed,
// on site, done, by its tint.
import React from 'react';
import '@/styles/tag-mark.css';

export const TagMark = ({ n, state }) => (
  <svg viewBox="0 0 28 40"
    className={`km-tag ${state || ''}${n >= 100 ? ' wide' : ''}`}
    role="img" aria-label={`${n} tag${n === 1 ? '' : 's'}`}>
    <path className="km-tag__body"
      d="M4 14 L14 4 L24 14 V35 a3 3 0 0 1 -3 3 H7 a3 3 0 0 1 -3 -3 Z" />
    <circle className="km-tag__hole" cx="14" cy="13" r="2.4" />
    <text className="km-tag__n" x="14" y="30" textAnchor="middle">{n}</text>
  </svg>
);

export default TagMark;
